import { Navigate, useLocation } from 'react-router-dom';

/* Will navigate to given path, including the searchParams */
export const RouteRedirect = ({ path }: { path: string }) => {
  const location = useLocation();
  const searchParams = location.search;

  return <Navigate to={`${path}${searchParams}`} />;
};
